import { assert, CheckedAddress } from '@sparkdotfi/common-universal'

import { getChainConfigEntry } from '@/config/chain'
import { TokenRepository } from '@/domain/token-repository/TokenRepository'
import { useTokenRepository } from '@/domain/token-repository/useTokenRepository'

export interface UsePointsTokenRepositoryParams {
  chainId: number
  account: CheckedAddress | undefined
}

export function usePointsTokenRepository({ chainId, account }: UsePointsTokenRepositoryParams): TokenRepository {
  const chainConfig = getChainConfigEntry(chainId)
  const pointsConfig = chainConfig.points
  assert(pointsConfig, 'Points config not available for this chain')

  return useTokenRepository({
    chainId,
    priceConfigs: pointsConfig.priceConfigs,
    account,
  })
}
